var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},[_vm._l((_vm.tagsToShow),function(tag,i){return _c('Tag',{key:i,attrs:{"tag":tag},on:{"clicked":_vm.tagClicked}})}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tagsToShow.length === 0),expression:"tagsToShow.length === 0"}],staticClass:"noTags"},[_vm._v(_vm._s(_vm.$t('tags.msg.noTags')))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }